import React from 'react'

export default function DatosDigitales () {
  return (
    <>
      <section id="contact" className="contact">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-12 d-flex align-items-stretch"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <h1>Política de Uso de Datos Digitales</h1>
            </div>
            <div
              className="col-lg-12 d-flex align-items-stretch"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="content-section">
                <h2>1. Introducción</h2>
                <p>
                  En [Nombre de la Empresa], nos comprometemos a proteger tu privacidad y la seguridad de tus datos personales. Esta política explica cómo recopilamos, usamos, almacenamos y protegemos tus datos.
                </p>
              </div>

            </div>
            <div
              className="col-lg-12 d-flex align-items-stretch"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="content-section">
                <h2>2. Datos que Recopilamos</h2>
                <p>
                  Podemos recopilar los siguientes datos:
                </p>
                <ul>
                  <li>Información de contacto: nombre, correo electrónico, número de teléfono.</li>
                  <li>Información sobre el dispositivo: dirección IP, navegador utilizado, ubicación aproximada.</li>
                  <li>Datos de comportamiento: cómo interactúas con nuestro sitio y qué funciones utilizas.</li>
                </ul>
              </div>
            </div>
            <div
              className="col-lg-12 d-flex align-items-stretch"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="content-section">
                <h2>3. Uso de los Datos</h2>
                <p>
                  Los datos recopilados se utilizan para:
                </p>
                <ul>
                  <li>Prestar el servicio que solicitas.</li>
                  <li>Mejorar la experiencia del usuario en la plataforma.</li>
                  <li>Enviar notificaciones y comunicaciones sobre actualizaciones o promociones (solo si has dado tu consentimiento).</li>
                </ul>
              </div>
            </div>
            <div
              className="col-lg-12 d-flex align-items-stretch"
              data-aos="fade-up"
              data-aos-delay="100"
            >

              <div className="content-section">
                <h2>4. Protección de los Datos</h2>
                <p>
                  Implementamos medidas de seguridad técnicas y organizativas para proteger tus datos frente a accesos no autorizados, pérdidas o alteraciones. Solo personal autorizado tiene acceso a tus datos personales.
                </p>
              </div>

            </div>
            <div
              className="col-lg-12 d-flex align-items-stretch"
              data-aos="fade-up"
              data-aos-delay="100"
            >

              <div className="content-section">
                <h2>5. Retención de los Datos</h2>
                <p>
                  Conservamos tus datos personales solo durante el tiempo necesario para cumplir con los fines para los que fueron recopilados, salvo que la ley exija un periodo más largo.
                </p>
              </div>
            </div>
            <div
              className="col-lg-12 d-flex align-items-stretch"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="content-section">
                <h2>6. Compartir los Datos</h2>
                <p>
                  No vendemos ni compartimos tus datos personales con terceros, salvo en los siguientes casos:
                </p>
                <ul>
                  <li>Proveedores de servicios que nos ayudan a operar la plataforma.</li>
                  <li>Cumplimiento de obligaciones legales.</li>
                </ul>
              </div>
            </div>
            <div
              className="col-lg-12 d-flex align-items-stretch"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="content-section">
                <h2>7. Derechos del Usuario</h2>
                <p>
                  Tienes derecho a acceder, rectificar o eliminar tus datos personales. También puedes oponerte al tratamiento de tus datos o solicitar la portabilidad de los mismos.
                </p>
              </div>
            </div>
            <div
              className="col-lg-12 d-flex align-items-stretch"
              data-aos="fade-up"
              data-aos-delay="100"
            >

              <div className="content-section">
                <h2>8. Modificaciones a la Política</h2>
                <p>
                  Podemos actualizar esta política en cualquier momento. Te notificaremos de cualquier cambio a través de los medios habituales.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
